import { CreateNote } from './CreateNote';
import { Logo } from './Logo';
import { NotesList } from './NotesList';
import { NotesListHeader } from './NotesListHeader';

const Notes: React.FC = () => {
    return (
        <div className="text-grey text-xs" data-testid="notes-dialog">
            <Logo />
            <hr className="my-4" />
            <CreateNote />
            <NotesListHeader />
            <NotesList />
        </div>
    );
};

export default Notes;
